import React from 'react'
interface Props {
  styleCssImage: string
}

const LogoTransferBancaire: React.FC<Props> = ({ styleCssImage } ) => {
  return (
    <svg className='xl:w-[55] xl:h-[55px] sm:w-[42] sm:h-[42px]'
      width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="59.9996" height="60" rx="10"
       fill="#20C374"
       className={`${styleCssImage}  `}

      // className='fill-[#1DB069] hover:fill-[#FFC000]'
        // fill="#20C374"
        />
      <path
        d="M17.8789 36.6215L36.5879 17.9126M40.1708 29.1227L36.9632 32.3303M34.2257 35.0352L32.7984 36.4625"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M17.631 36.5391C15.3469 34.255 15.3469 30.5517 17.631 28.2677L28.269 17.6297C30.5531 15.3456 34.2564 15.3456 36.5404 17.6297L43.3715 24.4609C45.6557 26.745 45.6557 30.4482 43.3715 32.7322L32.7336 43.3702C30.4495 45.6544 26.7463 45.6544 24.4622 43.3702L17.631 36.5391Z"
        stroke="white"
        strokeWidth="2"
      />
      <path d="M18.832 45.0834H42.1654" stroke="white" strokeWidth="2" strokeLinecap="round" />
    </svg>
  )
}

export default LogoTransferBancaire
